export default __webpack_public_path__ + "static/media/signatureIcon.0d489840.svg";